
import React from 'react';
import { promptCategories } from '../config/constants';

const GalleryCategory = ({ setCategory, category , showhome }) => {

    

    return (
        <div className={`__gallery-sec-category ${showhome && 'static'}` }>
            {/* <p>
                <DoubleArrow />
                {`${visibleData.length}/${data?.length} artworks in ${category === 'all' ? 'all' : category} category`}
            </p> */}

            <ul>
                {promptCategories.map((item, index) => (
                    <li
                        key={index}
                        className={category === item.value ? "active" : ""}
                        onClick={() => setCategory(item.value)}
                    >

                        {item.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default GalleryCategory;
